import { Box, Stack, Typography } from '@mui/material';

const NewComponentItem = ({ label, type, items, multiple, icon, handleDragStart, isDraggable = true }: any) => {
  return (
    <Stack
      alignItems="center"
      spacing={1}
      sx={{
        p: 1,
        cursor: isDraggable ? 'move' : 'auto',
        flexWrap: 'wrap'
      }}
      draggable={isDraggable}
      onDragStart={(e) => {
        handleDragStart(e, { label, type, items, multiple });
      }}
    >
      <Box sx={{ pt: 0.4 }}>{icon}</Box>
      <Typography sx={{ fontWeight: '400', fontSize: 16, color: '#565656', textAlign: 'center' }}>{label}</Typography>
    </Stack>
  );
};

export default NewComponentItem;
